interface OnboardingAccessSummary {
  mode: "preview" | "live";
  status: "invited" | "in_progress" | "completed";
  meetingBooked: boolean;
}

export interface CompletedOnboardingState {
  eyebrow: string;
  title: string;
  copy: string;
}

export function completedOnboardingState(
  onboarding: OnboardingAccessSummary,
): CompletedOnboardingState | null {
  if (
    onboarding.mode !== "live" ||
    onboarding.status !== "completed" ||
    !onboarding.meetingBooked
  ) {
    return null;
  }
  return {
    eyebrow: "Kickoff complete",
    title: "You’re all set.",
    copy: "You’ve already filled out and submitted your kickoff form. We’ll be in touch soon with next steps.",
  };
}
